import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';       // moved into /styles
import 'leaflet/dist/leaflet.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Leaflet marker icon fix (ensures default pin shows up)
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
